package pl.decks.personal.theme

import com.varabyte.kobweb.silk.theme.colors.ColorPalettes

internal object SiteColors {
    val Dark = ColorPalettes.Monochrome._800
    val Light = ColorPalettes.Monochrome._100

    val LighterDark = ColorPalettes.Monochrome._700
    val LighterLight = ColorPalettes.Monochrome._50

    val DarkerDark = ColorPalettes.Monochrome._900
    val DarkerLight = ColorPalettes.Monochrome._200

    val LightOrange = ColorPalettes.Orange._300
    val DarkOrange = ColorPalettes.Orange._800

    val LightBlue = ColorPalettes.Blue._300
    val DarkBlue = ColorPalettes.Blue._600

    val SystemsDimensionLight = ColorPalettes.Purple._300
    val SystemsDimensionDark = ColorPalettes.Purple._700

    val ProductDimensionLight = ColorPalettes.Indigo._300
    val ProductDimensionDark = ColorPalettes.Indigo._700

    val CultureDimensionLight = ColorPalettes.Green._300
    val CultureDimensionDark = ColorPalettes.Green._700

    val AnalyticsDimensionLight = ColorPalettes.Pink._300
    val AnalyticsDimensionDark = ColorPalettes.Pink._600

    val PlatformsDimensionLight = ColorPalettes.Cyan._300
    val PlatformsDimensionDark = ColorPalettes.Cyan._700

    val SoftwareDimensionLight = ColorPalettes.Lime._400
    val SoftwareDimensionDark = ColorPalettes.Lime._700

    val MilitaryBadgeLight = ColorPalettes.BlueGray._600
    val MilitaryBadgeDark = ColorPalettes.BlueGray._700
    val MilitaryBadgeDarker = ColorPalettes.BlueGray._800

    val InsigniaYellow = ColorPalettes.Yellow._800
    val InsigniaAmber = ColorPalettes.Amber._800
    val InsigniaOrange = ColorPalettes.Orange._900

    val BatteryBodyLight = ColorPalettes.BlueGray._600
    val BatteryBodyDark = ColorPalettes.BlueGray._700

    val BatteryEmptyDark = ColorPalettes.Red._600
    val BatteryLowDark = ColorPalettes.Red._400
    val BatteryMidDark = ColorPalettes.Orange._400
    val BatteryHighDark = ColorPalettes.LightGreen._500
    val BatteryFullDark = ColorPalettes.Green._500

    val BatteryEmptyLight = ColorPalettes.Red._600
    val BatteryLowLight = ColorPalettes.Red._400
    val BatteryMidLight = ColorPalettes.Orange._400
    val BatteryHighLight = ColorPalettes.LightGreen._500
    val BatteryFullLight = ColorPalettes.Green._500

}
